import React from "react";
import Invite from "../../component/invite";
export function Invitaion() {
  return <Invite />;
}
